import React from 'react'
import { history } from '../store'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchMachines, updateMachineTPV } from '../actions/machines'

import MachineStatusBadge from './MachineStatusBadge'
import MachineCashBadge from './MachineCashBadge'

class TPVList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: {}, // map of Serial => boolean
      tpvInputs: {} // map of Serial => input value
    };
  }

  startEditing = (serial, currentValue) => {
    this.setState(prev => ({
      editing: { ...prev.editing, [serial]: true },
      tpvInputs: { ...prev.tpvInputs, [serial]: currentValue }
    }));
  }

  cancelEditing = (serial) => {
    this.setState(prev => ({
      editing: { ...prev.editing, [serial]: false },
      tpvInputs: { ...prev.tpvInputs, [serial]: '' }
    }));
  }

  handleInputChange = (serial, value) => {
    this.setState(prev => ({
      tpvInputs: { ...prev.tpvInputs, [serial]: value }
    }));
  }

  handleSave = async (serial, machineId) => {
    const { tpvInputs } = this.state;
    const { updateMachineTPV, fetchMachines } = this.props;

    const newSerial = tpvInputs[serial];

    const response = await updateMachineTPV(machineId, { Tpv_serial: newSerial });

    // Refresh the machine list if update was successful
    if (!response.error) {
      if (typeof fetchMachines === 'function') {
        fetchMachines();
      }

      this.setState(prev => ({
        editing: { ...prev.editing, [serial]: false },
      }));
    } else {
      alert('Error actualizando el TPV Serial');
    }
  };

  goTo(Serial, e) {
    history.push(`/machines/${Serial}`)
  }

  getTPVPresent(machine) {

    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];

      if (device.Type == "TPV" && machine.Tpv_serial) {
        return true;
      }
    }
  }

  getDeviceModel(machine) {
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];
      if (device.Type === "TPV" && (device.Device === "PAYTEF" || device.Device === "SPIRE")) {
        return <span>SPu90</span>;
      } else if (device.Type === "TPV") {
        return <span>{device.Device}</span>;
      } else {
        return <span>NO DEVICE</span>;
      }
    }

    return <span>NO DEVICE</span>;
  }

  getPlatform(machine) {
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];
      if (device.Type === "TPV" && device.Device === "PAYTEF") {
        return <span>{device.Device}</span>;
      } else if (device.Type === "TPV" && device.Device === "Q5000") {
        return <span>WIPAY</span>;
      } else if (device.Type === "TPV" && device.Device === "Q6000") {
        return <span>COMERCIA</span>;
      } else if (device.Type === "TPV") {
        return <span>REDSYS</span>;
      }
    }
  }

  getDeviceType(machine) {

    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];

      if (device.Type == "TPV" && device.Device != "PAYTEF") {
        return true;
      }
    }
  }

  getMerchantCode(machine) {
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];

      if (device.Type == "TPV" && device.Device === "PAYTEF") {
        return true;
      }
    }
  }

  render() {
    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Máquina</th>
              <th scope="col">Cliente</th>
              <th scope="col">Modelo</th>
              <th scope="col">Plataforma</th>
              <th scope="col">SN</th>
              <th scope="col">Código de comercio</th>
              <th scope="col">TCOD</th>
              <th scope="col">Clave Firma</th>
              <th scope="col">Terminal</th>
            </tr>
          </thead>
          <tbody>
            {this.props.machines.map(machine => (
              <tr key={machine.Serial} className={this.getTPVPresent(machine) ? '' : 'bg-danger text-white'}>
                <th scope="row">{machine.Serial}</th>
                <td>
                  {(machine.Customer && machine.Customer.Fullname) || 'None'}
                </td>
                <td>
                  {this.getDeviceModel(machine)}
                </td>
                <td>
                  {this.getPlatform(machine)}
                </td>
                <td>
                  {this.state.editing[machine.Serial] ? (
                    <div className="d-flex align-items-center">
                      <input
                        className="form-control form-control-sm"
                        value={this.state.tpvInputs[machine.Serial] || ''}
                        onChange={(e) => this.handleInputChange(machine.Serial, e.target.value)}
                        style={{ maxWidth: '120px' }}
                      />
                      <button
                        className="btn btn-success btn-sm ml-1"
                        onClick={() => this.handleSave(machine.Serial, machine._id)}
                      >
                        <i className="fas fa-check"></i>
                      </button>
                      <button
                        className="btn btn-secondary btn-sm ml-1"
                        onClick={() => this.cancelEditing(machine.Serial)}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center">
                      <span>{machine.Tpv_serial || '-'}</span>
                      <button
                        className="btn bg-warning text-dark btn-outline-light btn-sm ml-2"
                        onClick={() => this.startEditing(machine.Serial, machine.Tpv_serial)}
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    </div>
                  )}
                </td>
                {this.getDeviceType(machine) ? (
                  <td>
                    {machine.TpvBusinessCode}
                  </td>
                ) : (<td>-</td>)
                }
                {this.getMerchantCode(machine) ? (
                  <td>
                    {machine.Tpv_tcod}
                  </td>
                ) : (<td>-</td>)
                }
                {this.getDeviceType(machine) ? (
                  <td>
                    {machine.TpvFirmKeyCode}
                  </td>
                ) : (<td>-</td>)
                }
                {this.getDeviceType(machine) ? (
                  <td>
                    {machine.TpvTerminalCode}
                  </td>
                ) : (<td>-</td>)
                }
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  updateMachineTPV: bindActionCreators(updateMachineTPV, dispatch),
})

export default connect(null, mapDispatchToProps)(TPVList)
